import { useState } from 'react'

import { AbsolutePopup, PopPaper, TPopupVertical } from 'core-components/library/popup'

import type { IAttentionStatusesReminder } from '../../types'

import { AttentionPbmPicker, type IAttentionPbmPickerPartner } from './AttentionPbmPicker'
import { AttentionPbmReplaceButton } from './AttentionPbmReplaceButton'

import styles from './AttentionPbmReplacement.module.scss'

interface IAttentionPbmReplacePopupProps {
  pbm: IAttentionStatusesReminder
  partners: IAttentionPbmPickerPartner[]
  assignedEmails?: string[]
  className?: string
}

/** The swap beside a PBM, opening the picker right at it. */
export const AttentionPbmReplacePopup = ({
  pbm,
  partners,
  assignedEmails,
  className,
}: IAttentionPbmReplacePopupProps) => {
  const [isOpened, setOpened] = useState(false)

  return (
    <AbsolutePopup
      rootClassName={styles.popupRoot}
      verticalStartPosition={TPopupVertical.Bottom}
      visibilityCallback={(visible) => {
        setOpened(visible)
        return visible
      }}
      popupContent={({ action }) => (
        <PopPaper shadowPosition="auto" className={styles.popup}>
          <AttentionPbmPicker
            pbm={pbm}
            partners={partners}
            assignedEmails={assignedEmails}
            onDone={action.close}
          />
        </PopPaper>
      )}
    >
      <AttentionPbmReplaceButton name={pbm.name} isOpened={isOpened} className={className} />
    </AbsolutePopup>
  )
}

AttentionPbmReplacePopup.displayName = 'AttentionPbmReplacePopup'
